// Self-contained data for the Jehannah Goldsmith Jewelry Repair Shop concept website.
export const BIZ = {
  name: "Jehannah Goldsmith Jewelry Repair Shop",
  brand: "JEHANNAH GOLDSMITH",
  sub: "Custom Gold & Silver · Repair · Cebu",
  tagline: "Custom-Made Pieces, Careful Repairs, Fair Scrap-Gold Buying",
  intro:
    "We're Jehannah Goldsmith, a small Cebu-area goldsmith and repair business. We make custom gold and silver pieces, repair jewelry, and buy scrap gold or pawnshop receipts.",
  areaNote: "Cebu City / Talisay-Cebu area — please message us to confirm our current storefront before visiting.",
  facebook: "https://www.facebook.com/jehannahgoldsmith/",
};

export const SERVICES = [
  { title: "Custom Gold & Silver Jewelry", text: "We make pieces to order in your chosen karat, weight and design." },
  { title: "Jewelry Repair", text: "Resizing, restringing, re-tipping and general repair work." },
  { title: "Scrap Gold Buying", text: "We buy old or broken scrap gold." },
  { title: "Pawnshop Receipts", text: "We also buy pawnshop receipts." },
];

export const PRODUCTS = [
  { name: "Panther-Style Diamond Bangle", desc: "Gold bangle with pavé stones and emerald eyes, panther-motif clasp.", img: "/jehannah/prod-panther-bangle.jpg" },
  { name: "Men's Rolex-Style Ring — 14g", desc: "14K/18K available, 16 accent stones, all sizes — spec sheet from a custom order.", img: "/jehannah/prod-mens-ring-spec.jpg" },
  { name: "Halo Engagement Ring VJR192 — 4g gold", desc: "14K/18K yellow or white gold, real or Swiss diamond options, all sizes.", img: "/jehannah/prod-halo-ring-spec.jpg" },
  { name: "Solitaire Ring VJR204 — 2g gold", desc: "A lighter solitaire design, same 14K/18K and diamond options.", img: "/jehannah/prod-solitaire-spec.jpg" },
  { name: "Oval Diamond Solitaire", desc: "Oval-cut center stone on a pavé split shank, shown boxed.", img: "/jehannah/prod-oval-diamond.jpg" },
];

export const STEPS = [
  { n: "1", title: "Describe Your Piece", text: "Message with your idea, repair need, or scrap gold to sell." },
  { n: "2", title: "Get a Spec & Quote", text: "Custom orders come with a gold-weight and stone spec sheet like the ones shown here." },
  { n: "3", title: "Confirm", text: "Approve the design, weight and price before work begins." },
  { n: "4", title: "Collect", text: "Pick up your finished or repaired piece once ready." },
];
